<script setup lang="ts" generic="T extends any">
import { computed } from 'vue';
import { type PropertyType } from './types';

const props = defineProps<{
  modelValue?: PropertyType<T>;
}>();

const emits = defineEmits<{
  'update:modelValue': [PropertyType<T>];
  blur: [Event];
}>();

function onUpdate(value: T) {
  emits('update:modelValue', { ...props.modelValue, value });
}

function onBlur(event: FocusEvent) {
  emits('blur', event);
}

const bindings = computed(() => ({
  props: {
    modelValue: props.modelValue?.value,
  },
  on: {
    'update:modelValue': onUpdate,
    blur: onBlur,
  },
}));
</script>

<template>
  <slot v-bind="bindings" />
</template>
